import _ from 'lodash';
import React from 'react';
import posed from 'react-pose';
import classNames from 'classnames';
import {keysToSingleValue} from '../utils/objectFactory';

export default function({pose, delay, duration}) {
    const poses = _.isArray(pose) ? pose : [pose];

    const Path = posed.path({
        ...keysToSingleValue(poses, {
            opacity: 1,
            pathLength: 100,
            pathOffset: 0,
            applyAtEnd: {opacity: 0},
            delay,
            transition: {
                opacity: {duration: 0},
                pathLength: () => ({
                    type: 'keyframes',
                    values: [0, 100, 100, 100],
                    times: [0, 0.4, 0.7, 1],
                    duration,
                }),
                pathOffset: () => ({
                    type: 'keyframes',
                    values: [0, 0, 0, 100],
                    times: [0, 0.4, 0.7, 1],
                    duration,
                }),
            },
        }),
        initial: {
            pathLength: 100,
            pathOffset: 0,
            opacity: 0,
            transition: {duration: 0},
        },
    });

    const Line = ({path, strokeWidth, strokeLinecap}) => (
        <Path
            stroke='#0a6b40'
            strokeWidth={strokeWidth}
            strokeLinecap={strokeLinecap}
            d={path}
        />
    );

    return function Nimbus({
        className,
        style,
        count,
        angle1,
        angle2,
        radius1,
        radius2,
        direction,
        strokeWidth = 30,
        strokeLinecap = 'square',
    }) {
        const normalizeAngle = x => (x + 360) % 360;
        let deltaAngle = normalizeAngle(angle2) - normalizeAngle(angle1);
        if (direction * deltaAngle < 0) {
            deltaAngle = 360 + deltaAngle;
        }
        const angleStep = deltaAngle / (count - 1);

        const mapCoordinate = value => Math.round(900 * value);

        const lines = _.range(count).map(index => {
            const angleDeg = angle1 + index * angleStep;
            const angle = (angleDeg / 180) * Math.PI;
            const x1 = mapCoordinate(radius1 * Math.cos(angle));
            const y1 = mapCoordinate(radius1 * Math.sin(angle));
            const x2 = mapCoordinate(radius2 * Math.cos(angle));
            const y2 = mapCoordinate(radius2 * Math.sin(angle));

            return `M${x1} ${y1} L${x2} ${y2}`;
        });

        return (
            <svg
                className={className}
                style={style}
                width='2000'
                height='2000'
                viewBox='-1000 -1000 2000 2000'
                preserveAspectRatio='none'
            >
                {lines.map(path => (
                    <Line
                        key={path}
                        path={path}
                        strokeWidth={strokeWidth}
                        strokeLinecap={strokeLinecap}
                    />
                ))}
            </svg>
        );
    };
}
